import styled, { css } from "styled-components";

/**
 * The shape of a record screen: a 70/30 row of white cards.
 *
 * These were written for the bowler screen and lived inside it, which meant
 * every other screen that wanted to look like the bowler screen wrote its own
 * near-copy -- 12px radius here, 8px there, #e5e7eb against #D5D9E5. Close
 * enough to look like a mistake rather than a different screen.
 *
 * They live here so "looks like the bowler screen" means the same code, not a
 * copy that drifts. The values are the bowler screen's own, moved verbatim.
 */

export const SectionContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 16px;
  height: auto;
  width: 100%;
  max-width: 420px;
  padding: 0;
  flex: 1 1 320px;

  @media only screen and (min-width: 992px) and (orientation: landscape) {
    min-height: 0;
    overflow-y: auto;
    align-self: stretch;
    max-width: none;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    max-width: 100%;
    flex: 1 1 100%;
  }

  @media only screen and (min-width: 768px) and (max-width: 1199px) and (orientation: portrait) {
    max-width: 100%;
    flex: 1 1 100%;
  }

  @media only screen and (max-width: 1163px) and (orientation: landscape) {
    padding: 0 6px;
  }

  ${(props) =>
    props.right &&
    css`
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: flex-start;

      @media only screen and (min-width: 992px) and (max-width: 1439px) and (orientation: landscape) {
        flex: 0 0 calc(30% - 8px);
        max-width: calc(30% - 8px);
      }
      @media only screen and (min-width: 1440px) {
        flex: 0 0 calc(30% - 8px);
        max-width: calc(30% - 8px);
      }
    `}

  ${(props) =>
    props.specsheet &&
    css`
      @media only screen and (min-width: 992px) and (orientation: landscape) {
        overflow: hidden;
      }
      @media only screen and (min-width: 992px) and (max-width: 1439px) and (orientation: landscape) {
        flex: 0 0 calc(70% - 8px);
        max-width: calc(70% - 8px);
      }
      @media only screen and (min-width: 1440px) {
        flex: 0 0 calc(70% - 8px);
        max-width: calc(70% - 8px);
      }
    `}
`;

export const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;

  ${(props) =>
    props.fillHeight &&
    css`
      @media only screen and (min-width: 992px) and (orientation: landscape) {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
    `}
`;

export const CardLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.8px;
  color: #6b7280;
  text-transform: uppercase;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ColumnsRow = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  box-sizing: border-box;

  @media only screen and (min-width: 992px) and (orientation: landscape) {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    flex-wrap: nowrap;
    justify-content: stretch;
  }

  @media only screen and (max-width: 767px) {
    padding: 12px;
    gap: 12px;
  }
`;
